export type MaskAccountNumberOptions = {
  showLast?: number;
  minimumMaskLength?: number;
  maxMaskLength?: number;
  normalizeDigits?: boolean;
  maskCharacter?: string;
};

export const maskAccountNumber = (
  value?: string,
  {
    showLast = 4,
    minimumMaskLength = 0,
    maxMaskLength,
    normalizeDigits = true,
    maskCharacter = '*',
  }: MaskAccountNumberOptions = {}
) => {
  const normalizedValue = normalizeDigits ? value?.replace(/\D/g, '') || '' : value || '';

  if (!normalizedValue) {
    return '';
  }

  if (showLast <= 0) {
    return maskCharacter.repeat(Math.max(normalizedValue.length, minimumMaskLength));
  }

  const visiblePortion = normalizedValue.slice(-showLast);
  const rawHiddenLength = normalizedValue.length - visiblePortion.length;

  const hiddenLength = Math.max(
    Math.max(
      minimumMaskLength,
      typeof maxMaskLength === 'undefined'
        ? rawHiddenLength
        : Math.min(rawHiddenLength, maxMaskLength - visiblePortion.length)
    ),
    0
  );

  if (!hiddenLength) {
    return visiblePortion;
  }

  return `${maskCharacter.repeat(hiddenLength)}${visiblePortion}`;
};
